'use client';
import { FC, useEffect, useState } from 'react';
import styles from './BookingCounter.module.scss';
import Plus from '../../app/assets/icons/plus.svg';
import Minus from '../../app/assets/icons/minus.svg';
import Image from 'next/image';
import classNames from "classnames";

interface BookingCounterProps {
  className?: string;
  quantity: number;
  setQuantity: (quantity: number) => void;
}

const BookingCounter: FC<BookingCounterProps> = ({ className = '', quantity, setQuantity }) => {
  const changeQuantity = (number: number) => {
    const newValue = quantity + number;

    // range from 1 to 5
    setQuantity(newValue < 1 ? 1 : newValue > 5 ? 5 : newValue);
  };

  return (
    <div className={classNames(styles.root, className)}>
      <button
        disabled={quantity === 1}
        onClick={() => {
          changeQuantity(-1);
        }}
        aria-label="decr">
        <Image src={Minus} alt="minus" />
      </button>
      <p>{quantity}</p>
      <button
        disabled={quantity === 5}
        onClick={() => {
          changeQuantity(1);
        }}
        aria-label="incr">
        <Image src={Plus} alt="Plus" />
      </button>
    </div>
  );
};

export default BookingCounter;
